import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/mynft.png";
import Particle from "../Particle";
import ProjectCard from "./ProjectCards";
import DVS from "../../Assets/Projects/o1.png";
import space from "../../Assets/Projects/gameplay.gif";
import gest from "../../Assets/Projects/gest.jpeg";
import {
  AiOutlineMail
} from "react-icons/ai";
import { 
  FaLinkedinIn,
  FaHackerrank
} from "react-icons/fa";
import {
  SiResearchgate, SiInstagram,SiTiktok
} from "react-icons/si";


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h2 style={{ fontSize: "2.6em" }}>
              Here are some values I live by:
            </h2>
            <p className="home-about-body">
              <h3><span className="purple">Kindness</span></h3>
              <ul>
                <li className="justi">You can be the smartest and most skilled software engineer in the world, but if you're not kind to those with whom you interact, you'll never reach your full potential and you'll always be chasing the next thing to bring you happiness in life. Be kind.</li>
              </ul>
              
              <h3><span className="purple">Adaptability</span></h3>
              <ul>
                <li className="justi">Life is going to throw you curve ball after curve ball and if you are not ready for them, you are going to strikeout. Your life and the life of those you surround yourself with are far too complex to confine yourself to one mould. Be adaptable and ready and willing to change when you need to.</li>
              </ul>

              <h3><span className="purple">Share knowledge</span></h3>
              <ul>
                <li className="justi">One of the biggest things that has helped me learn is by committing myself to sharing what I know with others.</li>
              </ul>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
              <a href="https://www.reddit.com/avatar/nft/polygon/466a330887bdf62d53f968ea824793150f07762e/784144?action=import" target="_blank" rel="noreferrer"className="mynft"><img src={myImg} className="img-fluid" alt="avatar" /></a>
          </Col>
        </Row>
        <Container fluid className="project-section">
        <Particle />
        <Container>
            <h2 className="project-heading">
            <strong>Some of my Projects</strong>
            </h2>
            <p style={{ color: "white" }}>
            Here are few projects I've worked on. Checkout Projects section or my GitHub for rest of my projects.
            </p>
            <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={4} className="project-card">
                <ProjectCard
                imgPath={DVS}
                isBlog={false}
                title="Dice Game"
                description="Dice Game, is a standalone multiplayer game created using MATLAB App and Python. Each player will roll the dice and player having bigger number in each roll will get a chance to perform action of choice (heal action or attack action)."
                ghLink="https://github.com/hemangsharma/B.Tech"
                />
            </Col>

            <Col md={4} className="project-card2">
                <ProjectCard
                imgPath={space}
                isBlog={false}
                title="Space Invasion"
                description="Space Invaders is a shoot 'em up arcade game developed by Hemang using Python"
                ghLink="https://github.com/hemangsharma/spaceinvasion"
                />
            </Col>

            <Col md={4} className="project-card2">
                <ProjectCard
                imgPath={gest}
                isBlog={false}
                title="Gesture Controller for Video Player"
                description="Gesture control is a breakthrough feature that give you full control of your devices, with just your hand gestures. It’s a whole new way of interacting with your device."
                ghLink="https://github.com/hemangsharma/Gestured-control-for-video-player"
                />
            </Col>
            </Row>
        </Container>
      </Container>

        <Row>
          <Col md={12} className="home-about-social">
            <h2>Feel free to connect with me</h2>
            <ul className="home-about-social-links">
              <li className="social-icons">
                  <a
                    href="mailto:sharmahemang2000@gmail.com"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiOutlineMail />
                  </a>
              </li>
            <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/sharmahemang/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.researchgate.net/profile/Hemang-Sharma-4"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <SiResearchgate />
                </a>
              </li>
            </ul>   
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
